<div class="modal-dialog-wrapper">
  <div class="title-wrapper">
    <div class="title">Create Room Item</div>
    <button (click)="close()">
      <mat-icon class="close-icon"> close </mat-icon>
    </button>
  </div>
  <div class="modal-create-item">
    <div class="steps-div">
      <div class="input-div">
        <mat-form-field class="email-input border-radius-10" appearance="outline">
          <mat-label>Item Name</mat-label>
          <input matInput placeholder="Item Name" [formControl]="itemName" />
        </mat-form-field>
      </div>
      <div class="image-div border-div">
        <input
          hidden
          type="file"
          #uploaderImg
          (change)="uploadImage($event)"
          accept="image/png, image/jpg, image/jpeg"
        />
        <div class="div-title">Add Item Image</div>
        @if (!imageSelected) {
          <div class="upload-empty" [matTooltip]="imageLabel">
            <button data-testid="uploadBtn" class="upload-btn" (click)="uploaderImg.click()">
              <div>Upload Image File</div>
              <div>
                <mat-icon class="add-icon">add</mat-icon>
              </div>
              <div class="sub-info">.jpeg, .jpg or .png</div>
            </button>
          </div>
        } @else {
          <div class="uploaded-file">
            <div class="title">Upload Image File</div>
            <div class="file-info">
              <div class="file-example">
                <div><mat-icon class="file-icon" svgIcon="IMAGE_UPLOADED"></mat-icon></div>
                <div class="file-name"><mat-icon>check</mat-icon> {{ imageData?.name }}</div>
              </div>
              <div>
                <button data-testid="removeBtn" (click)="removeImage()" class="secondary-button">Remove</button>
              </div>
            </div>
          </div>
        }
      </div>
      <div class="content-div border-div">
        <div class="div-title">
          <mat-slide-toggle
            [formControl]="addContent"
            (click)="enableButtonSection()"
            class="custom-toggle-scootaverse"
            hideIcon="true"
          >
            <span class="flex title items-center"> Add Content </span>
          </mat-slide-toggle>
        </div>

        @if (addContent.value) {
          <div>
            @if (urlLink.value.length > 0 || uploadedFilesLength > 0 || filesSelectedLength > 0) {
              <div class="reset-div" (click)="resetContent()"><mat-icon>keyboard_backspace</mat-icon> Back</div>
            }
            @if (urlLink.value.length === 0) {
              <div class="tab-menu users-tabs layout-v2">
                <mat-tab-group [(selectedIndex)]="selectedTab" animationDuration="0ms" mat-stretch-tabs="true">
                  <mat-tab>
                    <ng-template matTabLabel>Add File</ng-template>

                    <ng-template matTabContent>
                      @if (uploadedFilesLength > 0) {
                        <div class="tab-content table-div border-div">
                          <div class="subtitle">Uploaded Files</div>
                          <div class="table-div">
                            <table mat-table #uploadedFilesTable [dataSource]="uploadedFiles" class="custom-table">
                              <ng-container matColumnDef="name">
                                <th mat-header-cell *matHeaderCellDef>File Name</th>
                                <td mat-cell *matCellDef="let element">{{ element.fileName }}</td>
                              </ng-container>

                              <ng-container matColumnDef="type">
                                <th mat-header-cell *matHeaderCellDef>File Type</th>
                                <td mat-cell *matCellDef="let element">{{ formatFileType(element.fileName) }}</td>
                              </ng-container>

                              <ng-container matColumnDef="action">
                                <th mat-header-cell *matHeaderCellDef aria-label="row actions">&nbsp;</th>
                                <td mat-cell *matCellDef="let element; let i = index">
                                  <button mat-icon-button aria-label="action row" (click)="removeUploadedFile(i)">
                                    <mat-icon class="small-close-icon">close</mat-icon>
                                  </button>
                                </td>
                              </ng-container>

                              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                              <tr mat-row *matRowDef="let row; columns: displayedColumns; let i = index"></tr>
                            </table>
                          </div>
                        </div>
                      }
                      <div class="tab-content">
                        <input hidden type="file" #uploaderFile (change)="uploadFile($event)" />
                        <div class="upload-empty">
                          <button data-testid="uploadBtn" class="upload-btn" (click)="uploaderFile.click()">
                            <div>
                              @if (uploadedFilesLength > 0) {
                                Upload Another File
                              } @else {
                                Upload File
                              }
                            </div>
                            <div>
                              <mat-icon class="add-icon">add</mat-icon>
                            </div>
                          </button>
                        </div>
                      </div>
                    </ng-template>
                  </mat-tab>

                  <mat-tab>
                    <ng-template matTabLabel> Attach Existing File </ng-template>

                    <ng-template matTabContent>
                      <div class="tab-content">
                        <div class="border-div table-div attach-files">
                          <div class="subtitle">Attach Existing Files</div>
                          <div class="table-div">
                            @if (filesArray.length > 0) {
                              <table mat-table #existingFilesTable [dataSource]="filesArray" class="custom-table">
                                <ng-container matColumnDef="name">
                                  <th mat-header-cell *matHeaderCellDef>File Name</th>
                                  <td mat-cell *matCellDef="let element">{{ element.fileName }}</td>
                                </ng-container>

                                <ng-container matColumnDef="type">
                                  <th mat-header-cell *matHeaderCellDef>File Type</th>
                                  <td mat-cell *matCellDef="let element">{{ formatFileType(element.fileName) }}</td>
                                </ng-container>

                                <ng-container matColumnDef="select">
                                  <th mat-header-cell *matHeaderCellDef>
                                    <mat-checkbox
                                      class="navy-checkbox"
                                      (change)="$event ? toggleAllRows() : null"
                                      [checked]="selectedFiles.length > 0 && isAllSelected()"
                                      [indeterminate]="selectedFiles.length > 0 && !isAllSelected()"
                                    >
                                    </mat-checkbox>
                                  </th>
                                  <td mat-cell *matCellDef="let row">
                                    <mat-checkbox
                                      class="navy-checkbox"
                                      (click)="selectFile(row)"
                                      [checked]="checkFileSelected(row)"
                                    >
                                    </mat-checkbox>
                                  </td>
                                </ng-container>

                                <ng-container matColumnDef="action">
                                  <th mat-header-cell *matHeaderCellDef aria-label="row actions">&nbsp;</th>
                                  <td mat-cell *matCellDef="let element; let i = index">
                                    <button mat-icon-button aria-label="action row" (click)="removeUploadedFile(i)">
                                      <mat-icon class="small-close-icon">close</mat-icon>
                                    </button>
                                  </td>
                                </ng-container>

                                <tr mat-header-row *matHeaderRowDef="displayedColumnsFiles"></tr>
                                <tr mat-row *matRowDef="let row; columns: displayedColumnsFiles; let i = index"></tr>
                              </table>
                            } @else {
                              <div>There is no existing files.</div>
                            }
                          </div>
                        </div>
                      </div>
                    </ng-template>
                  </mat-tab>
                </mat-tab-group>
              </div>
            }

            @if (urlLink.value.length === 0 && uploadedFilesLength === 0 && filesSelectedLength === 0) {
              <div class="or">Or</div>
            }

            @if (uploadedFilesLength === 0 && filesSelectedLength === 0) {
              <div class="border-div link-div">
                <div class="subtitle">Add URL Link</div>
                <div class="input-div">
                  <mat-form-field class="email-input border-radius-10" appearance="outline">
                    <input matInput placeholder="www.mywebsite.com" [formControl]="urlLink" />
                    <mat-error>Invalid URL</mat-error>
                  </mat-form-field>
                </div>
              </div>
            }
          </div>
        }
      </div>
      <div class="button-div border-div">
        <div class="div-title">
          <mat-slide-toggle [formControl]="addButton" class="custom-toggle-scootaverse" hideIcon="true">
            <span class="flex title items-center"> Add Button </span>
          </mat-slide-toggle>
        </div>

        @if (addButton.value) {
          <div class="button-div-content">
            <div class="input-div">
              <mat-form-field class="email-input border-radius-10" appearance="outline">
                <mat-label>Button Text</mat-label>
                <input matInput placeholder="Button Text" [formControl]="buttonText" />
              </mat-form-field>
            </div>
            <div class="slider-div">
              <div class="title">Button Size</div>
              <div class="slider">
                <mat-slider
                  class="slider"
                  min="0"
                  max="2"
                  step="1"
                  aria-labelledby="group-size-slider"
                  [discrete]="false"
                  #ngSlider
                >
                  <input
                    placeholder="slider"
                    [formControl]="sliderControl"
                    matSliderThumb
                    #ngSliderThumb="matSliderThumb"
                  />
                </mat-slider>
                <span>{{ state$ | async }}</span>
              </div>
            </div>
            <div class="button-colors">
              <div class="select-color-div">
                <div class="title">Button Color</div>
                <div class="div-subtitle">Please select a background color</div>
                <div class="div-color">
                  <span
                    class="color-picked"
                    (click)="openColorPickerDialog(true)"
                    [style.background]="buttonColor"
                  ></span>
                  <span class="color-code">{{ buttonColor }}</span>
                </div>
              </div>

              <div class="select-color-div">
                <div class="title">Text Color</div>
                <div class="div-subtitle">Please select a background color</div>
                <div class="div-color">
                  <span
                    class="color-picked"
                    (click)="openColorPickerDialog(false)"
                    [style.background]="textColor"
                  ></span>
                  <span class="color-code">{{ textColor }}</span>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
      <div class="traversable-div border-div">
        <div class="div-title">
          <mat-slide-toggle [formControl]="itemTraversable" class="custom-toggle-scootaverse" hideIcon="true">
            <span class="flex title items-center">
              Make Item Traversable
              <mat-icon
                matTooltip="Traversable items will allow participants to navigate over them, non traversable items will become a barrier that the user will have tro navigate around."
                matTooltipPosition="right"
                class="info-icon"
              >
                info
              </mat-icon>
            </span>
          </mat-slide-toggle>
        </div>
      </div>
    </div>
    <div class="preview-section">
      <div class="preview-div">
        <div class="div-title">Room Preview</div>
        <div class="preview-item">
          @if (selectedImage) {
            <div class="item-div">
              <div class="item">
                <img
                  src="{{ selectedImage }}"
                  title="Preview Image Upload"
                  alt="Preview Image Upload"
                  class="image-upload"
                />
              </div>
            </div>
            @if (addButton.value) {
              <div class="button-div">
                <button
                  [ngStyle]="{ background: buttonColor, color: textColor }"
                  [ngClass]="getButtonClass(sliderControl.value)"
                  type="button"
                  aria-hidden="true"
                >
                  <div class="button-preview">{{ buttonPreviewValue }}</div>
                </button>
              </div>
            }
          } @else {
            <div>No Image to Preview</div>
          }
        </div>
      </div>
    </div>
  </div>
  <div class="footer-wrapper">
    <button
      data-testid="dialogPrimaryButton"
      class="primary-button"
      [disabled]="!enableCreateItemBtn()"
      mat-dialog-close
      (click)="confirm()"
    >
      {{ isEditItem ? 'Edit Room Item' : 'Create Room Item' }}
    </button>
  </div>
</div>
